import {Pipe, PipeTransform} from '@angular/core';
import {Duration, unitOfTime} from 'moment';
import {durationDisplaysByUnit} from "@shared/services/util/period-util.service";
import {MessageTranslateService} from "@shared/services";


interface DurationPipeOptions {
  units: unitOfTime.Base[];
  spaceBeforeUnit?: boolean;
  hideZeroForUnit?: boolean;
  abbreviated?: boolean;
}

const defaultUnits: unitOfTime.Base[] = ['year', 'month', 'day', 'hour', 'minute'];
const defaultOptions: DurationPipeOptions = {
  units: defaultUnits,
  spaceBeforeUnit: false,
  hideZeroForUnit: true,
  abbreviated: true
};


@Pipe({name: 'duration', standalone: false})
export class DurationPipe implements PipeTransform {

  constructor(private messageTranslateService: MessageTranslateService) {
  }

  transform(value: Duration, options?: DurationPipeOptions): string {
    const parts = [];
    const durationClone = value.clone();
    const coercedOptions = {
      ...defaultOptions,
      ...options
    };
    coercedOptions.units.forEach(unit => {
      const durationUnit = durationDisplaysByUnit.get(unit);
      if (!durationUnit) {
        throw new Error('Unsupported duration unit ' + unit);
      }
      const unitValue = Math.floor(durationClone.as(unit));
      if (unitValue || !coercedOptions.hideZeroForUnit) {
        parts.push(unitValue
          + (coercedOptions.spaceBeforeUnit ? ' ' : '')
          + this.messageTranslateService.instant(coercedOptions.abbreviated ? durationUnit.labelAbbreviated : durationUnit.label));
      }
      durationClone.subtract(unitValue, unit);
    });
    return parts.join(' ');
  }
}
